/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBold: {
  name: 'bold';
  data: string;
} = {
  name: 'bold',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 3h5.5a4.5 4.5 0 0 1 2.977 7.875A5.5 5.5 0 0 1 12.5 21H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 9v7h4.5a3.5 3.5 0 1 0 0-7 1 1 0 0 1-.25-.031A1 1 0 0 1 12 12H8Zm4.25-1.969A1 1 0 0 0 12 10H8V5h4.5a2.5 2.5 0 0 1 0 5 1 1 0 0 0-.25.031Z" fill="currentColor"/></svg>`,
};
